module.exports = __webpack_public_path__ + "static/media/deskDraft3.14dbd31c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/deskDraft3.jpg
// module id = 162
// module chunks = 0